<template>
<div>
    <h3 class="mt-3">{{index + 1}} - {{question.translation.name}}</h3>
    <span
        v-if="question.translation.description"
        v-html="question.translation.description"
        class="mb-3 d-block"
    />
    <fieldset
        :id="`question_id-${question.id}`"
        :class="{ verifyValidate: verifyValidate && error.has('option')}"
        class="p-1"
    >
        <label
            v-for="option in question.options"
            @mouseover="!isFinished ? onMouseOver(option.id): false"
            @mouseleave="onMouseLeave()"
            :id="`question_id-${question.id}`"
            :key="option.id"
            :style="[
                visualFeedback(option),
                hoverAnimation(color.primary, option.id),
                checkSelectCheckbox(option.id, model) && !exercise.show_answer ? onSelected(color.primary) : ''
            ]"
            class="btn-group d-flex align-items-center justify-content-between my-3"
        >
            <input
                v-model="model"
                @change="submitOption(option.id)"
                :disabled="isDisabled(option.id)"
                :name="`option-${option.name}`"
                :value="option.id"
                :id="option.id"
                class="mr-3 custom-control-input"
                data-vv-name="option"
                v-validate="'required'"
                type="checkbox"
            />

            <div>{{option.name}}</div>

            <span
                v-if="checkSelectCheckbox(option.id, model)"
                :style="`color:${color.primary}`"
                class="material-icons"
            >
                radio_button_checked
            </span>
        </label>
        <span
            v-if="error.has('option') && verifyValidate"
            class="invalid-feedback" style="display: block;"
        >
            {{ $t('exercise.validate.check_error') }}
        </span>
    </fieldset>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

import hoverEffect from '../../../../mixins/hoverEffect';

export default {
    name: 'ExerciseMultipleQuestion',
    mixins: [hoverEffect],
    data() {
        return {
            answers: [],
            model: [],
            rightQuestion: {
                'background-color': '#f5f5f5',
                'box-shadow': '0 0 0 3px #336e2f !important',
            },
            WrongQuestion: {
                'background-color': '#f5f5f5',
                'box-shadow': '0 0 0 3px #851818 !important',
            },
            error: this.$validator.errors,
        };
    },
    props: {
        question: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        isFinished: Boolean,
        verifyValidate: Boolean,
    },
    watch: {
        question(newVal) {
            this.model = newVal.answers ? newVal.answers : [];
        },
    },

    computed: {
        ...mapGetters({
            exercise: 'CLASS_EXERCISE',
            color: 'COLOR',
        }),
        max_correct() {
            return this.question.max_correct;
        },
    },

    methods: {
        async submitOption() {
            const response = await this.$store.dispatch('CLASS_EXERCISE_SUBMIT_OPTION', {
                questionId: this.question.id,
                answer: this.model
            })

            if (response === undefined) {
                this.answers = [];
                this.model = [];
                this.$notify({
                    type: 'danger',
                    message: this.$t('content.exercise.error.no_connection'),
                });
            }
        },

        checkSelectCheckbox(value, array) {
            return array.indexOf(value) !== -1;
        },

        isDisabled(id) {
            if (this.isFinished) return true;
            const disabled = this.model.length >= this.max_correct;
            if (this.model.includes(id)) return false;
            return disabled;
        },

        visualFeedback(option) {
            const showAnswer = this.exercise.show_answer;

            if (showAnswer && option.correct) {
                return this.rightQuestion;
            } else if (showAnswer && !option.correct && this.model.includes(option.id)) {
                return this.WrongQuestion;
            }
            return null;
        },
    },

    mounted() {
        const answers = this.question.answers;
        if (answers) this.model = answers;
    },
};
</script>
<style lang="sass">
.verifyValidate
    border-radius: 5px
    border: 2px solid red
</style>
